<template lang="">
  <canvas></canvas>
</template>
<script>
export default {
  name: "modelAndHero",
};
</script>
<style lang=""></style>
